module.exports = __webpack_public_path__ + "img/pengajian_by_abu_mudi.38f82920.webp";